import Language from "../../../Util/Language";

export const languages = {
    c_cpp: new Language("C++", "cpp"),
    java: new Language("Java", "java"),
    javascript: new Language("JavaScript", "javascript"),
    python: new Language("Python", "python"),
    kotlin: new Language("Kotlin", "kotlin"),
};

export const fontSizes = [12, 14, 16, 18, 20, 22, 24];

export const themes = [
    "chaos",
    "cobalt",
    "dracula",
    "github_dark",
    "merbivore_soft",
    "monokai",
    "nord_dark",
    "one_dark",
    "textmate",
    "tomorrow_night_blue",
    "tomorrow_night_eighties",
    "tomorrow_night",
    "xcode",
];
